var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.27 80.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#6534ff;}.cls-1,.cls-5{opacity:0.32;isolation:isolate;}.cls-3{fill:#f9879a;}.cls-4,.cls-6,.cls-7{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.55px;}.cls-4{stroke:#62bcfa;}.cls-5{fill:#3e1ec4;}.cls-6{stroke:#fff;}.cls-7{stroke:#bbc4ef;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-1",
    d: "M65.27,34.19l-2.71-4.63-.19-5.34a7.44,7.44,0,0,0-4-6.3l-3.75-2-2.12-3.59A7.51,7.51,0,0,0,46,8.63h-5.4L35.86,6.14a7.58,7.58,0,0,0-7.5.27L24.77,8.64H20.53a7.54,7.54,0,0,0-6.5,3.7L11.33,17,6.76,19.81a7.43,7.43,0,0,0-3.52,6.56l.16,4.2L1.28,34.21a7.35,7.35,0,0,0,0,7.42L4,46.26l.19,5.35a7.42,7.42,0,0,0,4,6.29l3.75,2L14,63.5a7.53,7.53,0,0,0,6.49,3.72H25v12a1,1,0,0,0,.57,1A1,1,0,0,0,26.68,80L33,74.76a1,1,0,0,1,1.33,0l6,5.17a1,1,0,0,0,1.69-.76v-12H46a7.53,7.53,0,0,0,6.49-3.72l2.7-4.63L59.79,56a7.43,7.43,0,0,0,3.52-6.56l-.16-4.2,2.12-3.64A7.35,7.35,0,0,0,65.27,34.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.63,77.94l-6-5.25a1,1,0,0,0-1.33,0L31,78a1,1,0,0,1-1.1.17,1,1,0,0,1-.57-1v-14a1,1,0,0,1,1-1h15a1,1,0,0,1,1,1V77.16a1,1,0,0,1-1.64.78Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    className: "cls-1",
    cx: 37.77,
    cy: 60.77,
    rx: 9.5,
    ry: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.27,31.53l-2.7-4.68-.18-5.4a7.54,7.54,0,0,0-4-6.35l-3.73-2L56.52,9.42A7.47,7.47,0,0,0,50,5.66h-5.4L39.86,3.15a7.48,7.48,0,0,0-7.49.27L28.78,5.68H24.54A7.51,7.51,0,0,0,18,9.43l-2.7,4.67L10.77,17a7.48,7.48,0,0,0-3.52,6.64l.15,4.24L5.28,31.52a7.52,7.52,0,0,0,0,7.51L8,43.71l.2,5.4a7.53,7.53,0,0,0,4,6.37l3.75,2L18,61.14a7.51,7.51,0,0,0,6.5,3.75h5.4l4.76,2.52a7.53,7.53,0,0,0,7.5-.28l3.61-2.25H50a7.51,7.51,0,0,0,6.5-3.75l2.7-4.68,4.57-2.88a7.5,7.5,0,0,0,3.52-6.63l-.16-4.24L69.28,39a7.5,7.5,0,0,0,0-7.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M65.27,20.45a7.49,7.49,0,0,0-4-6.36l-3.74-2L55.44,8.41A7.49,7.49,0,0,0,49,4.66H43.56L38.8,2.15a7.47,7.47,0,0,0-7.48.27L27.73,4.67H23.5A7.52,7.52,0,0,0,17,8.43L14.32,13.1,9.75,16A7.54,7.54,0,0,0,6.24,22.6l.15,4.27L4.28,30.54a7.5,7.5,0,0,0,0,7.5L7,42.71l.19,5.4a7.48,7.48,0,0,0,4,6.35l3.74,2L17,60.14a7.49,7.49,0,0,0,6.49,3.75h5.39l4.76,2.51a7.47,7.47,0,0,0,7.48-.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.55,27.76l-.19-5.34a7.4,7.4,0,0,0-4-6.26l-3.77-2L56.4,10.56a7.58,7.58,0,0,0-6.55-3.71H44.4l-1.13-.58A57.67,57.67,0,0,1,43.42,13c0,2.73.53,5.65,2.45,7.64a33.17,33.17,0,0,0,3.28,2.57,11.75,11.75,0,0,1,4.26,10.38C53,37,51,40.22,50.88,43.71c-.13,3.66,1.85,7.13,1.95,10.8A10.9,10.9,0,0,1,51,60.88c-1.05,1.54-2.49,2.82-3.46,4.39h2.33a7.57,7.57,0,0,0,6.55-3.7L59.11,57l4.62-2.83a7.37,7.37,0,0,0,3.55-6.55l-.16-4.18,2.14-3.62a7.29,7.29,0,0,0,0-7.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 36.27,
    cy: 55.27,
    rx: 23,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68,35.43h0a3.52,3.52,0,0,1-2.61,1.15H11.17a3.52,3.52,0,0,1-2.61-1.15h0a3.52,3.52,0,0,0-5.38.2L3,35.88a3.36,3.36,0,0,0-.59,3l3.24,11.9a4.82,4.82,0,0,0,4.66,3.51h56a4.81,4.81,0,0,0,4.66-3.51l3.24-11.9a3.36,3.36,0,0,0-.59-3l-.19-.25a3.52,3.52,0,0,0-5.38-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M7.51,36.42h0a3.5,3.5,0,0,0-2.72-1.14,3.44,3.44,0,0,0-2.62,1.35L2,36.88a3.39,3.39,0,0,0-.58,3L4.61,51.75a4.76,4.76,0,0,0,4.62,3.52H64.66a4.75,4.75,0,0,0,4.61-3.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M12.27,36.77h19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50.27,55.77h-12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M30.27,58.77h4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M17.27,15.27l11-7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBadge);
export default __webpack_public_path__ + "static/media/empty-badge.d7269d2de96e1ac6b3c9a95a69b132e4.svg";
export { ForwardRef as ReactComponent };